import { Button, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material"
import { Dialog, Stack } from "src/shared/components"
import { Close } from "@mui/icons-material"
import SelectPortField from "src/shared/container/select-port-field"
import SelectContainerTypeField from "src/shared/container/select-containertype-field"
import SelectVendorField from "src/shared/container/select-vendor-field"
import SelectDescriptionField from "src/shared/container/select-description-field"
import InputAutocomplete from "src/shared/components/input-autocomplete"
import { invoiceStatusOptions } from "src/api/modules/invoice-api"
import { Controller, useForm } from "react-hook-form"
import { ContainerInvoiceStatus } from "src/api/modules/container-api"

export type SyncPaymentContainerFormParams = {
  port?: IOptions | null
  containerType?: IOptions | null
  vendor?: IOptions | null
  description?: IOptions | null
  invoiceStatus?: ContainerInvoiceStatus
}
const SyncPaymentContainerModal = ({
  open,
  toggleDialog,
  onSubmit,
  paymentContainerParams
}: {
  paymentContainerParams?: SyncPaymentContainerFormParams
  open: boolean
  toggleDialog: () => void
  onSubmit: (data: any) => void
}) => {
  const { control, handleSubmit, getValues } = useForm({
    defaultValues: {
      port: null,
      containerType: null,
      vendor: null,
      description: null,
      invoiceStatus: ContainerInvoiceStatus.DRAFT
    },
    values: paymentContainerParams
  })
  console.log("getValues", getValues())
  const handleSubmitForm = (data: any) => {
    console.log("data-form submit", data)
    onSubmit(data)
  }
  return (
    <Dialog fullWidth maxWidth="md" open={open} toggleDialog={toggleDialog}>
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          <Typography variant="h6">Sync Payment Container</Typography>
          <IconButton onClick={() => toggleDialog()}>
            <Close />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Controller
              name="port"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <SelectPortField
                  label="Port"
                  value={(field.value as any)?.value ?? ""}
                  onChange={(val, valueObj) => field.onChange(val ? valueObj : null)}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Controller
              name="containerType"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <SelectContainerTypeField
                  label="Container Type"
                  value={(field.value as any)?.value ?? ""}
                  onChange={(val, valueObj) => field.onChange(val ? valueObj : null)}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Controller
              name="vendor"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <SelectVendorField
                  label="Vendor"
                  value={(field.value as any)?.value ?? ""}
                  onChange={(val, valueObj) => field.onChange(val ? valueObj : null)}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Controller
              name="description"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <SelectDescriptionField
                  label="Description"
                  value={(field.value as any)?.value ?? ""}
                  onChange={(val, valueObj) => field.onChange(val ? valueObj : null)}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Controller
              name="invoiceStatus"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <InputAutocomplete
                  label="Invoice Status"
                  value={invoiceStatusOptions?.find((option: IOptions) => option?.value === field?.value)}
                  onChange={(option: any) => field.onChange(option?.value)}
                  options={invoiceStatusOptions?.map(option => option.value)}
                  error={!!error}
                  helperText={error?.message}
                  disableClearable={true}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleSubmit(handleSubmitForm)}>
          Sync
        </Button>
        <Button variant="contained" color="secondary" onClick={() => toggleDialog()}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SyncPaymentContainerModal
